export const PROFILE_IMAGE_UPDATING = 'PROFILE_IMAGE_UPDATING'
export const PROFILE_IMAGE_UPDATE_SUCCESS = 'PROFILE_IMAGE_UPDATE_SUCCESS'
export const PROFILE_IMAGE_UPDATE_ERROR = 'PROFILE_IMAGE_UPDATE_ERROR'

export const GALLERY_IMAGE_UPDATING = 'GALLERY_IMAGE_UPDATING'
export const GALLERY_IMAGE_UPDATE_SUCCESS = 'GALLERY_IMAGE_UPDATE_SUCCESS'
export const GALLERY_IMAGE_UPDATE_ERROR = 'GALLERY_IMAGE_UPDATE_ERROR'
